import { render } from "./FormularioCategoria.vue?vue&type=template&id=6d2e42fe&scoped=true"
import script from "./FormularioCategoria.vue?vue&type=script&lang=js"
export * from "./FormularioCategoria.vue?vue&type=script&lang=js"

import "./FormularioCategoria.vue?vue&type=style&index=0&id=6d2e42fe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2e42fe"]])

export default __exports__